import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';
import { Role } from './role';

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  type: Role;
  token?: string;
  Adresse: string;
  BirthDate: string;
  CodeZip: string;
  Email: string;
  Enable: string;
  FirstName: string;
  LastName: string;
  NbrPasswordSaisie: string;
  Phone: string;
  Sexe: StringMapWithRename;
  typeVerification: string;
  Username: string;
  Ville: string;
  idUser: string;
  id_enreg: string;
  SoldeAvoir : string;
  SoldeWallet: string;
  id_unique: string;
  imageProfil: string;
  etat: string;
  smsValidation:string;
  idPays : string;
  Niveau: string;
  pinForPaiement:string;
}
